import { SCORE_TNT_BOOSTER } from '../../../Constants/Score';
import { CardType } from '../../../Prototype/Level/Card/CardType';
import {
    TActionType,
    TransactionType,
} from '../../../Utility/Tracking/DataSet/Transaction';
import { gameTracking } from '../../../Utility/Tracking/FBLegacyTracking';
import { FBTrackingEvent } from '../../../Utility/Tracking/FBTrackingEvent';
import { track, TrackMethod } from '../../../Utility/Tracking/Track';
import { trackTransaction } from '../../../Utility/Tracking/TrackingHelpers/Transaction';
import { IGameState } from '../../Game/IGameState';
import { setBoosterTNT } from '../../Player/PlayerInventoryHelper';
import CardStateHelper from '../CardStateHelper';
import { CardTask } from '../CardTasks';
import BaseBoosterBehavior from './BaseBoosterBehavior';

export default class TNTBoosterBehavior extends BaseBoosterBehavior {
    public play(state: IGameState): IGameState {
        // If there are not enough target cards, do nothing.
        if (!this.hasEnoughTargetCards(state)) return state;

        // Find all value cards that are face-up and not obscured.
        const targets = this.getTargetCards(state);

        // Using TNT booster restart streak score.
        state = CardStateHelper.cancelStreakScore(state);

        // Discard all.
        const targetScores = targets.map(cardID => {
            state = CardStateHelper.setCardDiscarded(state, cardID);
            state = CardStateHelper.increaseStreak(state, SCORE_TNT_BOOSTER);
            state = CardStateHelper.addTurnScore(
                state,
                state.levelState.cardsState.streakScore
            );
            return {
                cardID: cardID,
                score: state.levelState.cardsState.streakScore,
            };
        });

        // Task for animation.
        state = CardStateHelper.setStateTaskData(state, {
            task: CardTask.TNT,
            cards: targets,
            targets: targetScores,
        });

        // Check if cards need to be flipped.
        state = CardStateHelper.checkCardsObscured(state);

        track('tMassRemoveUsed', 1, TrackMethod.ADD);

        // Check for streak bonus.
        state = CardStateHelper.checkStreakBonus(state);

        return this.consumeItemOrCoins(state);
    }

    public getTargetCards(state: IGameState): string[] {
        return state.levelState.cardsState.inPlay.filter(cardID => {
            const card = state.levelState.cardsState.cards[cardID];
            const behavior = CardStateHelper.getCardBehavior(state, cardID);
            return (
                (card.type === CardType.value || card.type === CardType.gold) &&
                !behavior.isBlocked(state)
            );
        });
    }

    public hasEnoughTargetCards(state: IGameState): boolean {
        return this.getTargetCards(state).length > 0;
    }

    protected getPrice(state: IGameState): number {
        return state.levelState.boosterPrices.tnt;
    }

    protected getInventoryItem(state: IGameState): number {
        return state.playerState.inventory.boosterTNT;
    }

    protected spendInventoryItem(state: IGameState): IGameState {
        gameTracking(FBTrackingEvent.TapOnTNT);
        track('mMassRemoveUsed', 1, TrackMethod.ADD);
        track('tMassRemoveUsed', 1, TrackMethod.ADD);
        trackTransaction(
            state,
            TransactionType.INVENTORY,
            TActionType.BOOSTER_USE
        );

        return {
            ...state,
            playerState: setBoosterTNT(
                state.playerState,
                state.playerState.inventory.boosterTNT - 1,
                false
            ),
        };
    }

    protected spendCoins(state: IGameState): IGameState {
        state = super.spendCoins(state);

        gameTracking(FBTrackingEvent.TapOnTNT);
        track('tMassRemoveReceived', 1, TrackMethod.ADD);
        track('tMassRemoveUsed', 1, TrackMethod.ADD);
        track('mMassRemoveUsed', 1, TrackMethod.ADD);

        return state;
    }
}
